//REGISTER
export const POST_FAKE_REGISTER = "/post-fake-register"

//LOGIN
export const POST_FAKE_LOGIN = "/post-fake-login"
export const POST_FAKE_JWT_LOGIN = "/post-jwt-login"
export const POST_FAKE_PASSWORD_FORGET = "/fake-forget-pwd"
export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd"
export const SOCIAL_LOGIN = "/social-login"

//PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile"
export const POST_EDIT_PROFILE = "/post-fake-profile"

//PRODUCTS
export const GET_PRODUCTS = "/products"
export const GET_PRODUCTS_DETAIL = "/product"

//CALENDER
export const GET_EVENTS = "/events"
export const ADD_NEW_EVENT = "/add/event"
export const UPDATE_EVENT = "/update/event"
export const DELETE_EVENT = "/delete/event"
export const GET_CATEGORIES = "/categories"

//CHATS
export const GET_CHATS = "/chats"
export const GET_GROUPS = "/groups"
export const GET_CONTACTS = "/contacts"
export const GET_MESSAGES = "/messages"
export const ADD_MESSAGE = "/add/messages"

//ORDERS
export const GET_ORDERS = "/orders"

//CART DATA
export const GET_CART_DATA = "/cart"

//CUSTOMERS
export const GET_CUSTOMERS = "/customers"

//SHOPS
export const GET_SHOPS = "/shops"

//CRYPTO
export const GET_WALLET = "/wallet"
export const GET_CRYPTO_ORDERS = "/crypto/orders"

//INVOICES
export const GET_INVOICES = "/invoices"
export const GET_INVOICE_DETAIL = "/invoice"

//PROJECTS
export const GET_PROJECTS = "/projects"
export const GET_PROJECT_DETAIL = "/project"

//TASKS
export const GET_TASKS = "/tasks"

//CONTACTS
export const GET_USERS = "/users"
export const GET_USER_PROFILE = "/user"

//CROWDCARE
export const CC_GET_PROJECTS =
  "https://crowdcare.beuniq.my/api/get_projects_table"
export const CC_GET_DONORS = "https://crowdcare.beuniq.my/api/get_all_donors"
export const CC_GET_USER = "https://crowdcare.beuniq.my/api/get_users"
export const CC_GET_USER_DETAILS =
  "https://crowdcare.beuniq.my/api/get_user_details"
export const CC_POST_UPDATE_USER_DETAILS =
  "https://crowdcare.beuniq.my/api/update_user_details"
export const CC_POST_CREATE_USER = "https://crowdcare.beuniq.my/api/create_user"
export const CC_GET_DONATION_HISTORY_WITH_ID =
  "https://crowdcare.beuniq.my/api/get_donation_history"
export const CC_GET_APPLICATIONS =
  "https://crowdcare.beuniq.my/api/get_project_applications"
export const CC_GET_APPLICATION_DETAILS =
  "https://crowdcare.beuniq.my/api/get_project_application_details"
export const CC_POST_UPDATE_APPLICATION =
  "https://crowdcare.beuniq.my/api/update_project_application"
export const CC_POST_APPLICANT =
  "https://crowdcare.beuniq.my/api/submit_application"
export const CC_POST_UPDATE_PROJECT =
  "https://crowdcare.beuniq.my/api/update_project"
export const CC_POST_REJECT_APPLICATION =
  "https://crowdcare.beuniq.my/api/reject_project_application"
export const CC_POST_UPLOAD_PROJECT_IMAGE =
  "https://crowdcare.beuniq.my/api/upload_project_image"
export const CC_POST_DELETE_PROJECT_IMAGE =
  "https://crowdcare.beuniq.my/api/delete_project_image"
export const CC_GET_DONATION_DETAILS_WITH_ID =
  "https://crowdcare.beuniq.my/api/get_donation_history_details"
export const CC_POST_UPDATE_PROJECT_UPDATES =
  "https://crowdcare.beuniq.my/api/update_project_updates"
export const CC_POST_UNPUBLISH_PROJECT =
  "https://crowdcare.beuniq.my/api/unpublish_project"
export const CC_GET_AUDIT_LOG = "https://crowdcare.beuniq.my/api/get_audit_log"
export const CC_LOGIN = "https://crowdcare.beuniq.my/api/backend_login"
export const CC_GET_DASHBOARD = "https://crowdcare.beuniq.my/api/get_dashboard"

// G5
export const G5_GET_RECOGNITION =
  "https://g5.beuniq.my/api/get_recognition_list"
export const G5_DELETE_RECOGNITION =
  "https://g5.beuniq.my/api/delete_recognition"
export const G5_UPDATE_RECOGNITION =
  "https://g5.beuniq.my/api/update_recognition"
export const G5_POST_COMMENT = "https://g5.beuniq.my/api/insert_comment"
export const G5_DELETE_COMMENT = "https://g5.beuniq.my/api/delete_comment"
export const G5_POST_RECOGNITION = "https://g5.beuniq.my/api/insert_recognition"
export const G5_TOGGLE_REACTION = "https://g5.beuniq.my/api/toggle_reaction"
export const G5_GET_COMPANY_USER =
  "https://g5.beuniq.my/api/get_companyuserreceiver_list"
export const G5_GET_COMPANY_VALUE =
  "https://g5.beuniq.my/api/get_companyvalue_list"
export const G5_LOGIN = "https://g5.beuniq.my/api/login"
export const G5_REGISTRATION = "https://g5.beuniq.my/api/registration"
export const G5_GET_USERDETAIL = "https://g5.beuniq.my/api/get_user_details"
export const G5_GET_ALLOWANCESETTING =
  "https://g5.beuniq.my/api/get_allowance_setting"
export const G5_POST_ALLOWANCESETTING =
  "https://g5.beuniq.my/api/update_allowance_setting"
export const G5_GET_SETTING = "https://g5.beuniq.my/api/get_setting"
export const G5_POST_SETTING = "https://g5.beuniq.my/api/update_setting"
export const G5_POST_ADDVALUE = "https://g5.beuniq.my/api/add_companyvalue"
export const G5_POST_UPDATEVALUE =
  "https://g5.beuniq.my/api/update_companyvalue"
export const G5_POST_DELETEVALUE =
  "https://g5.beuniq.my/api/delete_companyvalue"
export const G5_GET_USER_TABLEDATA =
  "https://g5.beuniq.my/api/get_companyuser_list"
export const G5_GET_USER_EARNINGDATA =
  "https://g5.beuniq.my/api/get_earning_list"
export const G5_POST_IMPORTUSER = "https://g5.beuniq.my/api/import_user"
export const G5_POST_ADDUSER = "https://g5.beuniq.my/api/add_user"
export const G5_POST_UPDATEUSER = "https://g5.beuniq.my/api/update_user"
export const G5_POST_DELETEUSER = "https://g5.beuniq.my/api/delete_user"
export const G5_GET_COMPANY_INVITATION =
  "https://g5.beuniq.my/api/get_company_invitation"
export const G5_POST_CHECK_USER_INVITED =
  "https://g5.beuniq.my/api/check_user_invited"
export const G5_POST_UPDATE_USER_DETAILS =
  "https://g5.beuniq.my/api/update_user_details"
export const G5_POST_STRIPE_INTENT = "https://g5.beuniq.my/api/stripe_intent"
export const G5_GET_CHALLENGE_TABLE =
  "https://g5.beuniq.my/api/get_challenge_table"
export const G5_POST_CREATE_CHALLENGE =
  "https://g5.beuniq.my/api/create_challenge"
export const G5_POST_EDIT_CHALLENGE = "https://g5.beuniq.my/api/edit_challenge"
export const G5_GET_CHALLENGE_USER =
  "https://g5.beuniq.my/api/get_challenge_with_user"
export const G5_GET_CHALLENGE_USER_DETAILS =
  "https://g5.beuniq.my/api/get_challenge_details_with_user"
export const G5_GET_CHALLENGE_LEADERBOARD =
  "https://g5.beuniq.my/api/get_leaderboard_with_user"
export const G5_POST_DELETE_CHALLENGE =
  "https://g5.beuniq.my/api/delete_challenge"
export const G5_GET_ANALYTICS = "https://g5.beuniq.my/api/get_user_analytics"

// "https://sg.ugiftglobal.com/api/external/products/" //"http://47.241.176.8/api/external/products/"
// export const UGIFTDEV = "http://47.241.176.8"
// export const UGIFTDEV = "http://8.219.67.57"
export const UGIFTDEV = "https://sg.ugiftglobal.com"
export const UGIFT_STAGING_POST_GET_CATEGORY =
  UGIFTDEV + "/api/external/products/"
export const UGIFT_STAGING_POST_AUTH = UGIFTDEV + "/api/external/auth/"
export const UGIFT_STAGING_GIFT = UGIFTDEV + "/api/external/giftcards/"
export const UGIFT_STAGING_PROFILE = UGIFTDEV + "/api/external/profile/"
export const UGIFT_STAGING_EVOUCHER = UGIFTDEV + "/api/external/evoucher/"
export const UGIFT_STAGING_FRONTEND = UGIFTDEV + "/api/external/frontend/"
export const UGIFT_STAGING_BASKET = UGIFTDEV + "/api/external/basket/"
export const UGIFT_STAGING_ORDER = UGIFTDEV + "/api/external/order/"
export const UGIFT_STRIPE_ORDER =
  "https://uat-paas-gateway.e-buy.com/paas/micro/cashier/createTrade"
